import type { IdDocumentType } from '~domains/profile/entities/person';

export const idDocumentUploadLabels: { [K in IdDocumentType]: string } = {
  UMID: 'Your UMID photo',
  SSS: 'Your SSS ID photo',
  PRC: 'Your PRC ID photo',
  PASSPORT: 'Your Philippine passport photo',
  DRIVING_LICENSE: "Your Driver's license photo",
  PHIL_ID: 'Your PhilSys ID photo',
  POSTAL_ID: 'Your Postal ID photo',
  PHIL_SYS_ID: 'Your PhilSys ID (Card type) photo',
  DIGITAL_NATIONAL_PHIL_ID: 'Your Digital national ID photo',
  E_PHIL_ID: 'Your ePhil ID (Paper type) photo',
};
